import {
  SUPERSET_PROGRAMS_LIST,
  SUPERSET_PROGRAMS_LIST_SUCCESS,
  SUPERSET_PROGRAMS_LIST_ERROR,
  SUPERSET_PROGRAMS_LIST_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetProgramsList = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_PROGRAMS_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PROGRAMS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PROGRAMS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_PROGRAMS_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetProgramsList;
